import { Link } from 'react-router';

/**
 * `/privacy` and `/terms` — real legal/compliance text is not this project's
 * to write, so these are honest placeholders rather than fabricated policy.
 */
export function LegalPlaceholder({ title }: { title: string }): React.JSX.Element {
  return (
    <section aria-labelledby="legal-placeholder-heading">
      <Link to="/" className="back-link">
        ← Back to home
      </Link>
      <h2 id="legal-placeholder-heading">{title}</h2>
      <p className="hint" data-testid="legal-placeholder-notice">
        Content pending legal/compliance sign-off. Check back once this has been reviewed and
        published by BetterHome legal/compliance.
      </p>
    </section>
  );
}
